export default __webpack_public_path__ + "static/media/entreprisePortalPreview.6af44b08.png";